<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
  </div>
  <div class="row">
    <!-- SELECT TYPE DEAL -->
    <section class="col-12">
      <div class="card" [formGroup]="formGroupDetail">
        <!--TITLE-->
        <div class="card-title px-2 pt-2 mb-0">
          <h3>{{ "DETAIL_COMMISSION" | translate }}</h3>
        </div>
        <div class="card-body pb-0">
          <!--TYPE_SELECTION-->
          <div class="row">
            <div class="form-group col-xl-6 col-12">
              <label>{{ "CUSTOMER" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select bindLabel="name" bindValue="id" formControlName="customer" [placeholder]="'PLACEHOLDER.SELECT_CUSTOMER' | translate" (change)="filterDeals()" [multiple]="false" [searchable]="true"
                         [closeOnSelect]="true" [readonly]="(!!orderList && orderList[0].deal_id) || dealId" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="customersList"></ng-select>
            </div>
            <div class="form-group col-xl-6 col-12">
              <label>{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
              <input class="form-control" formControlName="name" [placeholder]="'PLACEHOLDER.INSERT_NAME' | translate" />
              <div class="invalid-feedback">{{ "ERRORS.FIELD_NAME" | translate }}</div>
            </div>
            <div class="form-group col-12 d-flex justify-content-end align-items-center" ngClass.sm="justify-content-between"
                 *ngIf="!orderList[0].deal_id && !!formGroupDetail.value.customer && !!formGroupDetail.value.name && _authService.hasCapability('create_order')">
              <div class="custom-control custom-control-primary custom-switch">
                <small class="mr-025">{{ "IS_A_DETACHMENT" | translate }}</small>
                <input type="checkbox" class="custom-control-input" id="detachment" formControlName="detachment" (click)="(orderList.length > 1 && selectedDeal ? false : null)" />
                <label class="custom-control-label" for="detachment"> </label>
              </div>
              <button class="btn btn-outline-primary" (click)="modalOpen(detailOrder, null)">{{ "CREATE_COMMISSION" | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--ADMINISTRATIVE DETAIL SECTION-->
    <section class="col-12" id="section2" *ngIf="!!orderList[0].deal_id">
      <div class="card" [ngClass]="activeTab === 'orders' ? 'active pb-0' : ''">
        <!--TITLE-->
        <div class="card-title px-2 mb-0" (click)="changeTab('orders')">
          <h3>{{ "ADMINISTRATIVE_DETAIL" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'orders' ? 'card-body p-0 mt-1' : 'd-none'" *ngIf="_utilService.isDesktop">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="60"
            [limit]="10"
            [footerHeight]="0"
            [rows]="orderList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'ROUND' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.progressive_id ? row.progressive_id : "-" }} {{ row.detachment_type ? "- " + row.detachment_type : null }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TITLES.USERS_TYPES.employee' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="text-break-line-1" [ngbTooltip]="row.employees_names ? row.employees_names : null">{{ row.employees_names ? row.employees_names : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FROM' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.from ? _utilService.formatDate(row.from) : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TO' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CAPACITY' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.capacity }} €</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'RESIDUE' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.residue }} €</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <button class="btn" [ngbTooltip]="'EDIT' | translate" (click)="modalOpen(detailOrder, row)" *ngIf="!row.detachment_type || row.detachment_type !== 'delta'"><i data-feather="edit-2"
                                                                                                                                                                               size="19"></i></button>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
        <div [ngClass]="activeTab === 'orders' ? 'card-body pb-0' : 'd-none'" *ngIf="_utilService.isTablet || _utilService.isMobile">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="270"
            [limit]="10"
            [footerHeight]="50"
            [rows]="orderList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'ROUND' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row">
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "ROUND" | translate }}: </span>
                    <span>{{ row.progressive_id ? row.progressive_id : "-" }} {{ row.detachment_type ? "- " + row.detachment_type : null }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "TITLES.USERS_TYPES.employee" | translate }}: </span>
                    <span class="text-break-line-1" [ngbTooltip]="row.employees_names ? row.employees_names : null">{{ row.employees_names ? row.employees_names : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "FROM" | translate }}: </span>
                    <span>{{ row.from ? _utilService.formatDate(row.from) : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "TO" | translate }}: </span>
                    <span>{{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "CAPACITY" | translate }}: </span>
                    <span>{{ row.capacity }} €</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "RESIDUE" | translate }}: </span>
                    <span>{{ row.residue }} €</span>
                  </div>
                  <div class="col-12 d-flex justify-content-end">
                    <button *ngIf="!row.detachment_type || row.detachment_type !== 'delta'" class="btn" [ngbTooltip]="'EDIT' | translate" (click)="modalOpen(detailOrder, row)">
                      <i data-feather="edit-2" size="19"></i>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
    <div class="col-12 text-right" *ngIf="!!orderList[0].deal_id">
      <button class="btn btn-primary" (click)="createCommission()">{{ "CREATE_COMMISSION" | translate }}</button>
    </div>
  </div>
</div>

<!-- Modal Detail Order -->
<ng-template #detailOrder let-modal>
  <form [formGroup]="formGroupOrder">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="!!orderList[0].deal_id ? modal.dismiss('Cross click') : goToDealsList()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "DETAIL_ROUND" | translate }}</h3>
      <div class="row">
        <div class="form-group col-xl-3 col-12">
          <div class="d-flex justify-content-between">
            <label>{{ "DEAL" | translate }}<sup class="text-danger">*</sup></label>
            <a class="font-small-3" target="_blank" [routerLink]="'/dashboard/deals/edit/' + selectedDeal.id" *ngIf="selectedDeal">{{ "VIEW_DEAL" | translate }}</a>
          </div>
          <ng-select bindLabel="complete_name" bindValue="id" formControlName="deal_id" [readonly]="!!dealId" [multiple]="false" [searchable]="true" [closeOnSelect]="true" (change)="selectDeal()" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="dealsFilteredList"></ng-select>
        </div>
        <ng-container *ngIf="selectedDeal">
          <div class="form-group col-xl-3 col-12">
            <label>{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
            <app-datepickr [defaultDate]="formGroupOrder.value.from" (onSelect)="takeDate($event, 'from'); calculateEffortTimeMaterial(); calculateTrancheNumberAndFrequency()" [isInvalid]="!formGroupOrder.value.from && showErrors"></app-datepickr>
            <div class="invalid-date" *ngIf="!formGroupOrder.value.from && showErrors">{{ "ERRORS.INSERT_FROM" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-12">
            <label>{{ "TO" | translate }}<sup class="text-danger">*</sup></label>
            <app-datepickr [defaultDate]="formGroupOrder.value.to" (onSelect)="takeDate($event, 'to'); calculateEffortTimeMaterial(); calculateTrancheNumberAndFrequency()" [isInvalid]="!formGroupOrder.value.to && showErrors"></app-datepickr>
            <div class="invalid-date" *ngIf="!formGroupOrder.value.to && showErrors">{{ "ERRORS.INSERT_TO" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-12">
            <label>{{ "PRODUCT_COMMISSION" | translate }}</label>
            <p class="mt-05 mb-0 font-small-3" *ngIf="productsCommissions.length < 1">{{ 'NO_PRODUCT_COMMISSION_FOR_THIS_CLIENT' | translate }}</p>
            <ng-select *ngIf="productsCommissions.length > 0" bindLabel="complete_name" bindValue="id" formControlName="product_commission_id" [virtualScroll]="false" [searchable]="true" [closeOnSelect]="true"
                       [multiple]="false" [hideSelected]="true" [clearable]="true" [openOnEnter]="false" [items]="productsCommissions" (clear)="formGroupOrder.patchValue({complete_name: null})"></ng-select>
          </div>
          <div class="form-group col-xl-{{ !formGroupDetail.value.detachment ? '6' : '4' }}">
            <label>{{ "BILLING_FREQUENCY" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" (change)="calculateTrancheNumberAndFrequency()"
                       class="{{ fieldHasErrors('billing_frequency') ? 'is-invalid' : '' }}" bindLabel="name" bindValue="id" formControlName="billing_frequency" [items]="billingFrequencyList"></ng-select>
            <div class="invalid-feedback">{{ "ERRORS.INSERT_BILLING_FREQUENCY" | translate }}</div>
          </div>
          <div class="form-group col-xl-{{ !formGroupDetail.value.detachment ? '6' : '4' }} col-12">
            <label>{{ "PAYAMENT_TERMS" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" class="{{ fieldHasErrors('payment_terms') ? 'is-invalid' : '' }}" bindLabel="name" bindValue="id" formControlName="payment_terms" [items]="paymentsTermsList"></ng-select>
            <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_TERMS" | translate }}</div>
          </div>
          <div class="form-group col-xl-6">
            <label>{{ "INVOICE_TYPE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" class="{{ fieldHasErrors('invoice_type') ? 'is-invalid' : '' }}" bindLabel="name" bindValue="id" formControlName="invoice_type" [items]="invoiceTypeList"></ng-select>
            <div class="invalid-feedback">{{ "ERRORS.INSERT_INVOICE_TYPE" | translate }}</div>
          </div>
          <div class="form-group col-xl-6">
            <label>{{ "PAYMENT_MEASURE_UNIT" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select [multiple]="false" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" class="{{ fieldHasErrors('payment_measure_unit') ? 'is-invalid' : '' }}"
                       bindLabel="name" bindValue="id" formControlName="payment_measure_unit" [items]="paymentMeasureUnitList" [readonly]="typeDeal === 'Task'"></ng-select>
            <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_MEASURE_UNIT" | translate }}</div>
          </div>
          <div class="form-group ml-1 custom-control custom-control-primary custom-switch col-12  mb-1" [ngClass.sm]="'ml-2'">
            <small class="mr-025">{{ "CUSTOMER_APPROVAL" | translate }}</small>
            <input type="checkbox" class="custom-control-input" id="customerApproval" formControlName="client_approval" />
            <label class="custom-control-label" for="customerApproval"> </label>
          </div>
          <div class="col-12 my-1">
            <h3 class="mb-0">{{ "ORDER" | translate }}</h3>
          </div>
          <div class="form-group col-xl-3 col-12">
            <label>{{ "ORDER_NUMBER" | translate }}</label>
            <input formControlName="order_number" name="order_number" type="text" maxlength="100" class="form-control" />
          </div>
          <div class="form-group col-xl-3 col-12">
            <label>{{ "ORDER_DATE" | translate }}</label>
            <app-datepickr [defaultDate]="formGroupOrder.value.order_date" (onSelect)="takeDate($event, 'order_date')"></app-datepickr>
          </div>
          <div class="form-group col-xl-3 col-12">
            <label>{{ "TYPE_ORDER" | translate }}</label>
            <ng-select [ngModelOptions]="{ standalone: true }" (change)="changeTypeDeal()" [(ngModel)]="typeDeal" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
              <ng-option value="Task">{{ "TASK" | translate }}</ng-option>
              <ng-option value="Time Material">{{ "TIME_MATERIAL" | translate }}</ng-option>
            </ng-select>
          </div>

          <div class="form-group col-xl-3 col-12">
            <div class="d-flex flex-sm-column flex-md-row justify-content-md-between align-items-md-center">
              <label>{{ "CAPACITY" | translate }}<sup class="text-danger">*</sup></label>
              <label class="text-danger font-small-2"
                     *ngIf="selectedDeal?.deal_document?.table[0]?.total_discounted_deal && selectedDeal?.deal_document?.table[0]?.total_discounted_deal !== selectedDeal?.deal_document?.table[0]?.total_deal">
                {{ "DISCOUNT_PROPOSED_TO_CUSTOMER" | translate }}: {{ selectedDeal?.deal_document?.table[0]?.total_discounted_deal }} € {{ "NOT_DISCOUNTED" | translate }}:
                {{ selectedDeal?.deal_document?.table[0]?.total_deal }} €
              </label>
            </div>
            <input (change)="formatMoneyValue('capacity')" formControlName="capacity" name="capacity" type="text" class="form-control {{ fieldHasErrors('capacity') ? 'is-invalid' : '' }}" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_CAPACITY" | translate }}</div>
          </div>
          <div class="form-group col-12">
            <label>{{ "ORDER_DESCRIPTION" | translate }}</label>
            <textarea formControlName="order_description" class="form-control {{ fieldHasErrors('order_description') ? 'is-invalid' : '' }}"></textarea>
            <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.order_description?.errors?.maxlength">{{ "ERRORS.DESCRIPTION_MAX_LENGTH" | translate }}</div>
          </div>
          <div class="form-group col-xl-6 col-12">
            <label>{{ "CIG_CODE" | translate }}</label>
            <input formControlName="order_cig" name="order_cig" maxlength="10" type="text" class="form-control {{ fieldHasErrors('order_cig') ? 'is-invalid' : '' }}" />
            <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.order_cig?.errors?.maxlength">{{ "ERRORS.CIG_MAX_LENGTH" | translate }}</div>
          </div>
          <div class="form-group col-xl-6 col-12">
            <label>{{ "CUP_CODE" | translate }}</label>
            <input formControlName="order_cup" name="order_cig" maxlength="15" type="text" class="form-control {{ fieldHasErrors('order_cup') ? 'is-invalid' : '' }}" />
            <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.order_cup?.errors?.maxlength">{{ "ERRORS.CUP_MAX_LENGTH" | translate }}</div>
          </div>
          <div class="col-12 mt-2">
            <h3>{{ "EMPLOYEES_DETAIL" | translate }}</h3>
          </div>
          <div class="form-group col-xl-6 col-12">
            <label>{{ "TITLES.USERS_TYPES.employee" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select bindLabel="complete_name" bindValue="hash" formControlName="employees_hash" [multiple]="true" [searchable]="true" [closeOnSelect]="true" [hideSelected]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="false" [items]="employeesList"
                       class="{{ fieldHasErrors('employees_hash') ? 'is-invalid' : '' }}" (change)="typeDeal && typeDeal === 'Time Material' ? manageTimeMaterialRow() : manageTaskRow()"></ng-select>
            <div class="invalid-feedback">{{ "ERRORS.EMPLOYEES_REQUIRED" | translate }}</div>
          </div>

          <div class="form-group col-xl-3 col-12" *ngIf="typeDeal && typeDeal === 'Task'">
            <label>{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
            <input formControlName="tranche_number" [readonly]="true" name="tranche_number" type="number" class="form-control {{ fieldHasErrors('tranche_number') ? 'is-invalid' : '' }}" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_NUMBER" | translate }}</div>
          </div>
          <div class="form-group col-xl-3 col-12" *ngIf="typeDeal && typeDeal === 'Task'">
            <label>{{ "TRANCHE_IMPORT" | translate }}<sup class="text-danger">*</sup></label>
            <input (change)="formatMoneyValue('tranche_import')" formControlName="tranche_import" type="text" class="form-control {{ fieldHasErrors('tranche_import') ? 'is-invalid' : '' }}" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_IMPORT" | translate }}</div>
          </div>
          <div class="col-12" *ngIf="typeDeal && typeDeal === 'Task'">
            <div class="row" *ngFor="let row of taskEmployee; let i = index">
              <div class="form-group col-xl-3 col-12">
                <label>{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select bindLabel="complete_name" bindValue="hash" [(ngModel)]="row.employee_hash" [readonly]="true" [multiple]="false" [searchable]="true" [closeOnSelect]="true" [ngModelOptions]="{ standalone: true }" [clearable]="false" [openOnEnter]="false"
                           [virtualScroll]="true" [items]="employeesList"></ng-select>
              </div>
              <div class="form-group col-xl-2 col-12">
                <label>{{ "MONTH_ACTIVITY" | translate }}<sup class="text-danger">*</sup></label>
                <input [(ngModel)]="row.months" name="months" type="text" class="form-control" [readonly]="true" [ngModelOptions]="{ standalone: true }" />
              </div>
              <div class="form-group col-xl-2 col-12">
                <label>{{ "MONTHLY_IMPORT" | translate }}<sup class="text-danger">*</sup></label>
                <input (change)="formatMonthlyImport(i)" [(ngModel)]="row.monthly_import" type="text" class="form-control" [ngModelOptions]="{ standalone: true }" />
              </div>
              <div class="form-group col-xl-2 col-12">
                <label>{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                <input [(ngModel)]="formGroupOrder.value.tranche_number" name="tranche_number_employee_" type="text" class="form-control" [readonly]="true" [ngModelOptions]="{ standalone: true }" />
              </div>
              <div class="form-group col-xl-3 col-12">
                <label>{{ "TRANCHE_IMPORT_EMPLOYEE" | translate }}<sup class="text-danger">*</sup></label>
                <input [(ngModel)]="row.tranche_single_import" [readonly]="true" type="text" class="form-control" [ngModelOptions]="{ standalone: true }" />
              </div>
            </div>
          </div>

          <!--For timeMaterial for each employee we have days_number and daily_rate-->
          <div class="col-12" *ngIf="typeDeal && typeDeal === 'Time Material'">
            <div class="row" *ngFor="let row of timeMaterialEmployee; let i = index">
              <div class="form-group col-xl-4 col-12">
                <label>{{ "TITLES.USERS_TYPES_SINGULAR.employee" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select bindLabel="complete_name" bindValue="hash" [(ngModel)]="row.employee_hash" [readonly]="true" [multiple]="false" [searchable]="true" [closeOnSelect]="true" [ngModelOptions]="{ standalone: true }" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="employeesList"></ng-select>
              </div>
              <div class="form-group col-xl-4 col-12">
                <label>{{ "DAYS_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
                <input (change)="calculateCapacityTimeMaterial()" [(ngModel)]="row.effort" type="number" class="form-control" [ngModelOptions]="{ standalone: true }" />
              </div>
              <div class="form-group col-xl-4 col-12">
                <label>{{ "DAILY_RATE" | translate }}<sup class="text-danger">*</sup></label>
                <input (change)="formatDailyRate(i); calculateCapacityTimeMaterial()" [(ngModel)]="row.daily_rate" type="text" class="form-control" [ngModelOptions]="{ standalone: true }" />
              </div>
            </div>
          </div>
          <div class="form-group col-12">
            <label>{{ "ROUND_DESCRIPTION" | translate }}</label>
            <textarea formControlName="description" type="text" class="form-control {{ fieldHasErrors('description') ? 'is-invalid' : '' }}"></textarea>
            <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.description?.errors?.maxlength">{{ "ERRORS.DESCRIPTION_MAX_LENGTH" | translate }}</div>
          </div>

          <div class="form-group col-xl-4 col-12" *ngIf="selectedDeal && formGroupDetail.value.detachment">
            <label>{{ "DETACHMENT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select bindLabel="name" bindValue="name" formControlName="detachment_type" (change)="filterDeals()" [multiple]="false" [searchable]="true" [closeOnSelect]="true" [readonly]="true"
                       [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="detachmentTypes"></ng-select>
            <div class="font-error" *ngIf="showErrors && !formGroupOrder.value.detachment_type">{{ "ERRORS.INSERT_DETACHMENT_TYPE" | translate }}</div>
          </div>
        </ng-container>
      </div>
      <!--File Section-->
      <div class="row mt-1" *ngIf="selectedDeal">
        <div class="col-xl-6 col-12" ngClass.xl="border-right" ngClass.md="mb-1" ngClass.sm="mb-1">
          <h3>{{ "DOCUMENT_ORDER" | translate }}</h3>
          <div class="row">
            <div class="col-xl-6 col-12">
              <div id="file-uploader" class="custom-file mt-1">
                <input class="custom-file-input" type="file" lang="it" id="file" [multiple]="false" (change)="addFileToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="files_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetFilesList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-11 mt-3 border-top pt-1" *ngIf="files_list_obj.length > 0">
              <div *ngFor="let file of files_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeFileFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ files_list_obj.length }}</div>
            </div>
            <div class="col-12 mt-1" *ngIf="files_list_obj.length < 1">
              <p>{{ "NO_ORDER_FILE_SELECTED" | translate }}</p>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-12">
          <h3>{{ "ATTACHMENTS_ORDER" | translate }}</h3>
          <div class="row">
            <div class="col-xl-6 col-12">
              <div id="attachment-uploader" class="custom-file mt-1">
                <input class="custom-file-input" type="file" lang="it" id="attachment" [multiple]="true" (change)="addAttachmentToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="attachments_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetAttachmentsList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3 border-top pt-1" *ngIf="attachments_list_obj.length > 0">
              <div *ngFor="let file of attachments_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ attachments_list_obj.length }}</div>
            </div>
            <div class="col-12 mt-1" *ngIf="attachments_list_obj.length < 1">
              <p>{{ "NO__ORDER_ATTACHMENTS_SELECTED" | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center" *ngIf="selectedDeal">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')" rippleEffect *ngIf="!!orderList[0].deal_id">
        {{ "BACK" | translate }}
      </button>
      <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="createOrder()">
        {{ "SAVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Detail Order -->
